import React from "react";
import DeviceTypes  from "../modules/DeviceTypes/DeviceTypes";
export default function DeviceTypesPage() {
  return <DeviceTypes />;
}
